import React, {Component} from 'react';
import { inject, observer } from 'mobx-react';
import moment from "moment";

import AirModal from '../../../../../common/components/AirModal';
import AirButton from '../../../../../common/components/AirButton';

import './CreateRouteTask.css';
import AirInput from "../../../../../common/components/AirInput";
import RouteIcon from "../../../../../common/icons/RouteIcon";

@inject('translationsStore', 'routeTaskStore', 'commonStore')
@observer
export default class CreateRouteTask extends Component
{
  constructor(props) {
    super(props);

    this.state = {
      visible: false
    };
  }

  show = () => {
    this.setState({ visible: true });
  };

  hide = () => {
    this.setState({
      visible: false,
      name: undefined,
      date: undefined,
      time: undefined,
      note: undefined,
      positionDetails: null
    });
  };

  onChange = (e) => {
    this.setState({ groupId: e.target.value });
  };

  transformToGeoJson = (address) => {
    const {lng, lat} = address;
    delete address.lng;
    delete address.lat;

    return {
      position: {
        type: 'Point',
        coordinates: [lng, lat]
      },
      positionDetails: address
    };
  };

  onSubmit = () => {
    const { name, position, date, time, note, positionDetails } = this.state;
    const { commonStore, routeTaskStore } = this.props;

    const formattedDatetime = `${date.format('YYYY-MM-DD')} ${time.format('HH:mm')}`;

    this.hide();
    commonStore.setLoading(true);
    routeTaskStore.create(name, position, formattedDatetime, note, positionDetails).then(() => {
      commonStore.setLoading(false);
    });

  }

  disabledDateBeforeToday = current => {
    return current && (current < moment().startOf('day'));
  };

  render() {
    const { translationsStore } = this.props;
    const { visible, name, position, date, time, note } = this.state;

    const disabled = !name || !position || !date || !time;

    return (
      <AirModal
        className="CreateRouteTaskModal"
        width='840px'
        visible={visible}
        icon={<RouteIcon style={{ width: '60px', height: '40px' }} />}
        title={translationsStore.translate('routePlanning.createRoute.modal.title')}
        onCancel={this.hide}
        okButton={<AirButton disabled={disabled} size="large" light label={translationsStore.translate('routePlanning.createRoute.modal.buttonLabel')} />}
        onOk={() => !disabled && this.onSubmit()}
      >
        <AirInput label={translationsStore.translate('routePlanning.createRoute.modal.name')} value={name} onChange={(e) => this.setState({name: e.target.value})} />
        {this.state.visible && <AirInput
          type='location'
          label={translationsStore.translate('routePlanning.createRoute.modal.address')}
          onSelect={(location) => this.setState({...this.transformToGeoJson(location)})}
          onCancelSearch={() => this.setState({position: null, positionDetails: null})}
          center={{
            lat: 45.316267,
            lng: 8.857712
          }}
        />}
        <div className="RouteInputRow">
          <AirInput type='date' label={translationsStore.translate('routePlanning.createRoute.modal.date')} value={date} onChange={(date) => this.setState({date})} disabledDate={this.disabledDateBeforeToday}/>
          <AirInput type='time' label={translationsStore.translate('routePlanning.createRoute.modal.time')} value={time} onChange={(time) => this.setState({time})} />
        </div>
        <AirInput label={translationsStore.translate('routePlanning.createRoute.modal.note')} value={note} onChange={(e) => this.setState({note: e.target.value})} />
      </AirModal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/RouteTaskDashboard/SubHeader/CreateRouteTask/CreateRouteTask.js